import { HslaColor, HslColor } from 'polished/lib/types/color';

export const hslToHsv = (
  c: HslColor | HslaColor
): { hue: number; saturation: number; value: number } => {
  const v = c.lightness + c.saturation * Math.min(c.lightness, 1 - c.lightness);
  const s = v === 0 ? 0 : 2 * (1 - c.lightness / v);
  return { hue: c.hue, saturation: s, value: v };
};
